import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
export const Signup = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }
    // Handle signup logic here
    console.log('Signup with:', fullName, email, password);
  };
  return <AuthCard title="Create an account" subtitle="Fill in your details to get started with TailorPro" data-id="element-75">
      <form onSubmit={handleSubmit} data-id="element-76">
        <Input id="fullName" label="Full Name" placeholder="John Doe" value={fullName} onChange={e => setFullName(e.target.value)} required data-id="element-77" />
        <Input id="email" label="Email" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-78" />
        <Input id="password" label="Password" type="password" placeholder="••••••••" value={password} onChange={e => {
        setPassword(e.target.value);
        setPasswordError('');
      }} required data-id="element-79" />
        <Input id="confirmPassword" label="Confirm Password" type="password" placeholder="••••••••" value={confirmPassword} onChange={e => {
        setConfirmPassword(e.target.value);
        setPasswordError('');
      }} error={passwordError} required data-id="element-80" />
        <Button type="submit" variant="primary" fullWidth className="mt-2" data-id="element-81">
          Create Account
        </Button>
        <div className="mt-6 text-center text-sm text-gray-500" data-id="element-82">
          Already have an account?{' '}
          <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium" data-id="element-83">
            Login
          </Link>
        </div>
      </form>
    </AuthCard>;
};